var map = {
	"./1/symbol_0.png": 57536,
	"./1/symbol_1.png": 28713,
	"./1/symbol_2.png": 63570,
	"./1/symbol_3.png": 12571,
	"./1/symbol_4.png": 2628,
	"./1/symbol_5.png": 45133,
	"./1/symbol_6.png": 38102,
	"./1/symbol_7.png": 16191,
	"./1/symbol_8.png": 9640,
	"./1/symbol_9.png": 65937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61792;